import PropTypes from "prop-types";

import ChallengeCountdown from "@/challenges/ChallengeCountdown";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import {
  container,
  heading,
  headingWrapper,
  subHeading,
  subHeadingWrapper,
} from "./ChallengeLandingHeader.style";

const propTypes = {
  expirationDate: PropTypes.any,
};

const ChallengeLandingHeader = ({ expirationDate }) => {
  const { data: user } = useUser();
  const { isTeacher } = getUserProperties(user);
  const month = expirationDate?.toLocaleString("en-GB", { month: "short" });
  const date = expirationDate?.getDate();
  const now = new Date();
  const countdown = Math.floor(
    (expirationDate?.getTime() - now?.getTime()) / (1000 * 3600 * 24),
  );
  const todayMonth = now?.toLocaleString("en-GB", { month: "long" });
  return (
    <div css={container}>
      <div css={headingWrapper}>
        <h2 css={heading}>
          {todayMonth.charAt(0).toUpperCase() + todayMonth.slice(1)} reading
          challenge
        </h2>
      </div>
      {!isTeacher && (
        <div css={subHeadingWrapper}>
          <p css={subHeading(true)}>1. Find content</p>
          <p css={subHeading(true)}>2. Complete activities</p>
          <p css={subHeading(false)}>3. Earn tokens</p>
        </div>
      )}
      <ChallengeCountdown month={month} date={date} countdown={countdown} />
    </div>
  );
};

ChallengeLandingHeader.propTypes = propTypes;

export default ChallengeLandingHeader;
